import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { ApplicationState } from 'AppReducer'

const UserCard: React.FC = () => {
  const { user } = useSelector((state: ApplicationState) => state.userReducer)

  if (!user) {
    return null
  }

  const defaultPicture = `${process.env.PUBLIC_URL}/img/default-user.png`
  return (
    <div className="row panel" style={{ padding: 16 }}>
      <img
        width={130}
        height={130}
        alt="User Profile"
        className="shadow margin-right-16"
        src={user.person.picture || defaultPicture}
        style={{ borderRadius: '50%', border: '5px solid white' }}
      />
      <div className="grow">
        <div className="row justify-start">
          <h2>
            { user.person.name } &bull;&nbsp;
            {
              user.isActive
                ? <span style={{ color: 'green' }}>Ativo</span>
                : <span style={{ color: 'red' }}>Inativo</span>
            }
          </h2>
          <p className="col-12">{ user.person.email } </p>
        </div>
      </div>
      <NavLink to={`/panel/user/${user.id}`} className="button secondary ">Editar Usuário</NavLink>
    </div>
  )
}

export default UserCard
